import { CommonUtilities } from 'commonUtils';
import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';

export default function ProductStatusUpsert(param: any) {

    let [ProductStatus, setProductStatus] = useState<any>(param?.editDataDawer ?? []);

    const closeDrawer = () => { param.closeDrawer() }

    const onReset = () => {
        console.log(param?.editDataDawer)
        if (param?.editDataDawer) {
            ProductStatus = param?.editDataDawer
            setProductStatus(ProductStatus)
        }
    }

    const onSave = () => {
        systemFormatsList.saveStatusProduct(ProductStatus).then((respond: any) => {
            CommonUtilities.showToastDawer('Product Status Saved', 'Success')
        })
    }

    return (<>
        <Drawer open={param?.openUpsertUX} direction='right' className='react-drawer allowHscroll ' size={800}>

            <div className="pull-right ws-5 box full-height-vh " >

                <div className="ws-12 bg-blue ">
                    <h1 className="pull-left text-center mt mll">Add Product Status</h1>
                    <i className="icon-close pull-right pLarge" onClick={closeDrawer}></i>
                </div>

                <div className="box-content">
                    <div className="ws-12">

                        <div className="ws-12">
                            <div className="form-format">
                                <label className="control-label" > Product Status UseID</label>

                                <div className="label-entries">
                                    <input type="number" placeholder="Product Status Use ID" ng-disabled="IsDisabled" data-ng-model="productStatus.productStatusUseID" id="productStatusUseID" name="productStatusUseID" />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label" >Product Status Name</label>

                                <div className="label-entries">
                                    <input type="text" placeholder="Product Status Name" data-ng-model="productStatus.productStatusName" id="productStatusName" name="productStatusName" />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label"> Product Status Short Code </label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Product Status Short Code" data-ng-model="productStatus.ProductStatusShortCode" id="productStatusShortCode" name="productStatusShortCode" />
                                </div>
                            </div>
                        </div>

                        <div className="ws-12">

                            <div className="form-format">
                                <label className="control-label">Analysis DIM 1</label>

                                <div className="label-entries">
                                    <input type="text" data-ng-model="productStatus.AnalysisDIM1" name="analysisDiM1" id="frmsetAnalysis.analysisDiM1" placeholder="Analysis DIM 1" />
                                </div>
                            </div>

                            <div className="form-format">
                                <label className="control-label">Analysis DIM 2</label>

                                <div className="label-entries">
                                    <input type="text" data-ng-model="productStatus.AnalysisDIM2" name="analysisDIM2" id="frmsetAnalysis.AnalysisDIM2" placeholder="Analysis DIM 2" />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label" >Analysis DIM 3</label>

                                <div className="label-entries">
                                    <input type="text" data-ng-model="productStatus.AnalysisDIM3" name="analysisDIM3" id="frmsetAnalysis.AnalysisDIM3" placeholder="Analysis DIM 3" />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label" >Analysis DIM 4</label>

                                <div className="label-entries">
                                    <input type="text" data-ng-model="productStatus.AnalysisDIM4" name="analysisDIM4" id="frmsetAnalysis.AnalysisDIM4" placeholder="Analysis DIM 4" />
                                </div>
                            </div>
                        </div>

                        <div className="ws-12">
                            <div className="ws-6">

                                <div className="ws-12 pb pt">
                                    SongYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="productStatus.songYN" />
                                        <span className="slider round text-left white pm pts " ng-show="productStatus.songYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!productStatus.songYN =='1'">No</span>
                                    </label>
                                </div>

                                <div className="ws-12 pb pt">
                                    TrackYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="productStatus.trackYN" />
                                        <span className="slider round text-left white pm pts " ng-show="productStatus.trackYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!productStatus.trackYN =='1'">No</span>
                                    </label>
                                </div>

                                <div className="ws-12 pb pt">
                                    ReleaseYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="productStatus.releaseYN" />
                                        <span className="slider round text-left white pm pts " ng-show="productStatus.releaseYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!productStatus.releaseYN =='1'">No</span>
                                    </label>
                                </div>

                                <div className="ws-12 pb pt">
                                    CueYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="productStatus.cueYN" />
                                        <span className="slider round text-left white pm pts " ng-show="productStatus.cueYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!productStatus.cueYN =='1'">No</span>
                                    </label>
                                </div>
                            </div>

                            <div className="ws-6">

                                <div className="ws-12 pb pt">
                                    ShowHideYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="productStatus.showHideYN" />
                                        <span className="slider round text-left white pm pts " ng-show="productStatus.showHideYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!productStatus.showHideYN =='1'">No</span>
                                    </label>
                                </div>

                                <div className="ws-12 pb pt">
                                    OwnedYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="productStatus.ownedYN" />
                                        <span className="slider round text-left white pm pts " ng-show="productStatus.ownedYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!productStatus.ownedYN =='1'">No</span>
                                    </label>
                                </div>

                                <div className="ws-12 pb pt">
                                    InterCoYN
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="productStatus.interCoYN" />
                                        <span className="slider round text-left white pm pts " ng-show="productStatus.interCoYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!productStatus.interCoYN =='1'">No</span>
                                    </label>
                                </div>

                                <div className="ws-12 pb pt">
                                    IsDefault
                                    <label className="switch mr">
                                        <input type="checkbox" data-ng-model="productStatus.isDefault" />
                                        <span className="slider round text-left white pm pts " ng-show="productStatus.isDefault=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!productStatus.isDefault =='1'">No</span>
                                    </label>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
                {/* Footer */}
                <div className="box-footer ws-12 pull-right">
                    <button type="button" className="icon-btn delete pull-right" onClick={closeDrawer}>x Close</button>
                    <button type="button" className="icon-btn delete pull-right" onClick={onReset}>↻ Reset</button>
                    <button type="button" className="icon-btn edit pull-right" onClick={onSave}>✔ Save </button>
                </div>
            </div>

        </Drawer>
    </>)
}